// Зеркало состояния грязных таблиц для потребителей вне React-дерева
// (WebSocketProvider и т.п.), которым нужен синхронный snapshot без hook-подписки.
export const dirtyTableIds = new Set<string>();
export const getDirtyTableIdsSnapshot = (): string[] => Array.from(dirtyTableIds);
export const hasAnyDirtyTables = (): boolean => dirtyTableIds.size > 0;
